import { makeStyles } from 'tss-react/mui';
export const useTabStyles = makeStyles()(theme => ({
  normalText: {
    textTransform: 'none',
  },
  tabRoot: {
    color: theme.appColors.iconsType,
    fontSize: 12,
    marginRight: theme.spacing(2),
    maxHeight: 18,
    minHeight: 18,
    minWidth: 'auto',
    padding: 0,
  },
  tabsRoot: {
    '& [role=tablist]': {
      alignItems: 'center',
      height: '100%',
    },
  },
}));
